import { ReactNode } from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { DevTool } from '@hookform/devtools';

interface DevToolsProviderProps {
  children: ReactNode;
}

export const DevToolsProvider = ({ children }: DevToolsProviderProps) => {
  const isDevelopment = import.meta.env.DEV;

  if (!isDevelopment) {
    return <div>{children}</div>;
  }

  return (
    <>
      {children}
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
      {/* React Hook Form DevTools will be attached to individual forms */}
    </>
  );
};

export { DevTool as HookFormDevTools };
